import { render, staticRenderFns } from "./noContent.vue?vue&type=template&id=51df629a&scoped=true&"
import script from "./noContent.vue?vue&type=script&lang=js&"
export * from "./noContent.vue?vue&type=script&lang=js&"
import style0 from "./noContent.vue?vue&type=style&index=0&id=51df629a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51df629a",
  null
  
)

export default component.exports